var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGearIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48",
    strokeWidth: 3,
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cog--work-loading-cog-gear-settings-machine"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.158 4.362c.115-.24.281-.451.517-.575.56-.294 1.868-.787 4.326-.787 2.458 0 3.765.493 4.325.787.236.124.402.335.518.575.335.7 1.082 2.314 1.643 3.92a16.982 16.982 0 0 1 3.878 2.242c1.672-.317 3.447-.477 4.222-.537.265-.02.531.018.756.16.535.339 1.616 1.224 2.844 3.353 1.23 2.129 1.456 3.507 1.482 4.14.01.266-.089.515-.24.735-.439.641-1.464 2.097-2.574 3.386a17.157 17.157 0 0 1 0 4.478c1.11 1.29 2.135 2.745 2.574 3.386.15.22.25.47.24.735-.026.633-.253 2.011-1.482 4.14-1.229 2.129-2.31 3.014-2.844 3.353-.225.142-.49.18-.757.16-.775-.06-2.549-.22-4.22-.537a16.978 16.978 0 0 1-3.878 2.243c-.562 1.605-1.309 3.218-1.644 3.92-.116.24-.282.45-.518.574-.56.294-1.867.787-4.325.787s-3.765-.493-4.326-.787c-.236-.124-.402-.334-.517-.575-.335-.7-1.083-2.314-1.644-3.92a16.985 16.985 0 0 1-3.878-2.242c-1.672.317-3.446.477-4.22.537-.266.02-.532-.018-.757-.16-.535-.339-1.616-1.224-2.845-3.353-1.229-2.129-1.455-3.507-1.48-4.14-.012-.266.088-.515.239-.735.439-.641 1.464-2.097 2.574-3.386a17.159 17.159 0 0 1 0-4.478c-1.11-1.29-2.135-2.745-2.575-3.386-.15-.22-.25-.47-.24-.735.027-.633.253-2.011 1.482-4.14 1.23-2.129 2.31-3.014 2.844-3.353.226-.142.491-.18.757-.16.775.06 2.55.22 4.221.537a16.979 16.979 0 0 1 3.878-2.243c.561-1.605 1.309-3.219 1.644-3.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 540",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14 24a10 10 0 1 0 20 0 10 10 0 1 0-20 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGearIcon);
export default __webpack_public_path__ + "static/media/gear-icon.6f0d370f1bc02599eee4bfaf33f5c0a3.svg";
export { ForwardRef as ReactComponent };